<template>
<div id="frame" >
  <div v-if="loaded">
      <card :title="title" :subTitle="subtitle" v-if="tick === 1" id="frame">
        
          
              <v-text-field
                  v-model="date"
                  label="Datum"
                  type="date"
                  readonly
              ></v-text-field>
              <v-text-field
                  v-model="time"
                  label="Uhrzeit"
                  type="time"
                  readonly
              ></v-text-field>
              
              <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
                <v-list-tile >
                  <v-list-tile-action>
                    <v-checkbox v-model="checkPoint.check" readonly></v-checkbox>
                  </v-list-tile-action>
                  
                    {{checkPoint.text}}
                  
                </v-list-tile>
                <br>
                <br>
              </div>
              <v-text-field
                  v-model="name"
                  :error-messages="nameErrors"
                  label="Ihr Name"
                  @input="$v.name.$touch()"
                  @blur="$v.name.$touch()"
                  required
                  readonly
              ></v-text-field>
              <v-select
                  v-model="selectedFahrzeug"
                  :items="fahrezeuge"
                  item-text="name"
                  item-value="name"
                  :label="labelFahrzeug"
                  return-object
                  attach
                  required
              >
              </v-select>
              <v-text-field
                  v-model="bemerkung"
                  label="Bemerkung"
                  readonly
              ></v-text-field>
              <p class="boldtxt">Foto vom Innenraum des Fahrerhauses: </p> 
              <div class="fileinputs" v-if="!imageFahrerhaus">
                Es wurde kein Foto erstellt!
              </div>
              <div v-else>
                  <img :src="imageFahrerhaus" />
              </div>
              <br>
              <p class="boldtxt">Foto von der Ladefläche:</p>
              <div  class="fileinputs" v-if="!imageLadeflaeche">
                Es wurde kein Foto erstellt!
              </div>
              <div v-else>
                  <img :src="imageLadeflaeche" />
                
              </div>
              <br>
              <v-divider/>
              <!-- <v-btn @click="submit">submit</v-btn> -->
              <button class="btn btn-lg btn-danger float-left" v-on:click="back()" type="button">zurück</button>  
              
          
      </card>

      <card :title="title2" v-if="tick === 2" id="frame">
          <hr>
          <!-- bestätigen --> 
          <div class="angaben">
              <p class="messstelle">{{title}}</p>
              <p>Datum: {{formatDate(date)}}</p>
              <p>Uhrzeit: {{time}}</p>
              <p>Ihr Name: {{name}}</p>
              <p>Fahrzeug: {{selectedFahrzeug.name}}</p>
              <p>Bemerkung: {{bemerkung}}</p>
          </div>
          <hr>
          <!-- unterschrift -->
          <div class="signature">  
              <VueSignaturePad
                  width="100%"
                  height="200px"
                  ref="signaturePad"
                  saveType="image/png"
                  class="pad"
              />
              <p class="instruction">Bitte hier unterschreiben!</p>
          </div>
          <button class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>    
          <button class="btn btn-lg btn-success float-right" v-on:click="save()" type="button">bestätigen</button>
      </card>

      <div class="alert alert-success" v-if="tick === 3" id="alert">
          <!-- Erfoglsmeldung -->
          <button type="button" aria-hidden="true" class="close"></button>
          <span>
          <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
      </div>
      <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
        <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
        <span>
          <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
        </span>
      </div>  
  </div>
  <div v-else>
  <center>
      <v-progress-circular
      :size="70"
      :width="7"
      color="red"
      indeterminate
    ></v-progress-circular>
  </center>
  </div>
</div>

</template>

<script>
import { validationMixin } from 'vuelidate';
import { numeric, required} from 'vuelidate/lib/validators';

export default {
mixins: [validationMixin],

validations: {
    name: { required },
},
  data () {     
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      checkPoints:[
        {checkPoint: 1, check: false, text: "Es befindet sich keinerlei Müll im Fahrerhaus"},
        {checkPoint: 2, check: false, text: "Es befinden sich keine alten Lieferscheine im Fahrerhaus"},
        {checkPoint: 3, check: false, text: "Es befinden sich keinerlei leeren/angetrunkenen Pfandflaschen im Fahrerhaus"},
        {checkPoint: 4, check: false, text: "Es befinden sich keine Klappboxen im Fahrerhaus"},
        {checkPoint: 5, check: false, text: "Es befinden sich keine leeren Tüten/Taschen im Fahrerhaus"},
        {checkPoint: 6, check: false, text: "Es befindet sich keinerlei retournierte Ware mehr im Fahrzeug (muss ins Büro)"},
        {checkPoint: 7, check: false, text: "Es befindet sich keinerlei Kunden-Leergut mehr im Fahrzeug"},
        {checkPoint: 8, check: false, text: "Es befindet sich keine TK-Ware mehr in der Truhe"},
        {checkPoint: 9, check: false, text: "Die Tiefkühl-Truhe wurde abgeschaltet (nur Spätschicht)"},
        {checkPoint: 10, check: false, text: "Der Laderaum wurde mit einem Handfeger gereinigt"},
        {checkPoint: 11, check: false, text: "Es befinden sich keine Klappboxen im Laderaum"},
        {checkPoint: 12, check: false, text: "Evtl. Schäden/Defekte wurden gemeldet (WA)"},
      ],
      fahrezeuge:[
      ],
      selectedFahrzeug: {},
      imageFahrerhaus: "",
      imageLadeflaeche:"",
      labelFahrzeug: "Fahrzeug",
      loaded: false,

      

        active: true,
        switchlbl: "Messstelle aktiv",
        tick: 1,
        title: "Checkliste - Fahrer",
        subtitle: "Checkliste ",
        title2: "Angaben bestätigen und unterzeichnen",
        date: "",
        time:"",
        name: "",
        signature: "",
        bemerkung: "",
        showErrorMessage: false,
    }
    },


    mounted() {
        
    },
    watch: {
      
    },
    methods: {
        onFileChangeLadeflaeche(e) {
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length)
            return;
          this.createImageLadeflaeche(files[0]);
        },
        createImageLadeflaeche(file) {
          var imageLadeflaeche = new Image();
          var reader = new FileReader();
          var vm = this;

          reader.onload = (e) => {
            vm.imageLadeflaeche = e.target.result;
          };
          reader.readAsDataURL(file);
        },
        removeImageLadeflaeche: function (e) {
          this.imageLadeflaeche = '';
        },
        
        onFileChangeFahrerhaus(e) {
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length)
            return;
          this.createImageFahrerhaus(files[0]);
        },
        createImageFahrerhaus(file) {
          var imageFahrerhaus = new Image();
          var reader = new FileReader();
          var vm = this;

          reader.onload = (e) => {
            vm.imageFahrerhaus = e.target.result;
          };
          reader.readAsDataURL(file);
        },
        removeImageFahrerhaus: function (e) {
          this.imageFahrerhaus = '';
        },
        disableNotification(){
            this.showErrorMessage = false;
        },
        nextTick(){
           
            this.$v.$touch();
            if (!this.$v.$invalid) {
                
                    if(!_.isEmpty(this.selectedFahrzeug) ){
                        this.labelFahrzeug = "Fahrzeug";
                        this.tick =  this.tick + 1;
                    }else{
                        this.labelFahrzeug = "Bitte Fahrzeug auswählen!";
                        
                    }
              
            } 


        },
        cancel(){
            this.tick = 1;
        },
        back(){
            this.$router.push({path: "/checklists/driver"});
        },
        formatDate(date){
            var today = new Date(date);
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            var date = dd+ '.' + mm + '.' + yyyy;
            return date;
        },
        createToday(){

            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            var date = yyyy+ '-' + mm + '-' + dd;
            this.date = date;
            this.time = (today.getUTCHours()+1) + ':' + today.getUTCMinutes();
      
        },
        fetchChecklist(){
            
        console.log("abrufen der Checkliste aus der DB")
        this.$http.get(process.env.VUE_APP_NODE_API_URL+'/heimspiel/checklist/driver/'+this.$route.params.id, { headers: {'Authorization': this.auth }})
            .then(function(response){
            console.log(response)
                  
            var checklistDate = new Date(response.body.data[0].datum);
            var dd = String(checklistDate.getDate()).padStart(2, '0');
            var mm = String(checklistDate.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = checklistDate.getFullYear();
            var date = yyyy+ '-' + mm + '-' + dd;


            this.date = date;
            this.time = response.body.data[0].uhrzeit;
            this.name = response.body.data[0].name;
            this.signature = response.body.data[0].unterschrift;
            this.bemerkung = response.body.data[0].bemerkung;
            this.fahrezeuge = [{name: response.body.data[0].fahrzeug}];
            this.selectedFahrzeug = response.body.data[0].fahrzeug;
            this.imageFahrerhaus = response.body.data[0].fahrerhaus;
            this.imageLadeflaeche = response.body.data[0].ladeflaeche;
            this.checkPoints[0].check = response.body.data[0].check1;
            this.checkPoints[1].check = response.body.data[0].check2;
            this.checkPoints[2].check = response.body.data[0].check3;
            this.checkPoints[3].check = response.body.data[0].check4;
            this.checkPoints[4].check = response.body.data[0].check5;
            this.checkPoints[5].check = response.body.data[0].check6;
            this.checkPoints[6].check = response.body.data[0].check7;
            this.checkPoints[7].check = response.body.data[0].check8;
            this.checkPoints[8].check = response.body.data[0].check9;
            this.checkPoints[9].check = response.body.data[0].check10;
            this.checkPoints[10].check = response.body.data[0].check11;
            this.checkPoints[11].check = response.body.data[0].check12;
            this.loaded = true;
          
            });
        },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (!isEmpty) {
                
                
                this.signature = data;
                this.nextTick();
                for(var counter = 0; counter < this.checkPoints.length ; counter++){
                    if(this.checkPoints[counter].check == false){
                        this.checkPoints[counter].check = 0;
                    }else{
                        this.checkPoints[counter].check = 1;
                    }
                }
                
    
                let checklist = {  
                    fahrzeug: this.selectedFahrzeug.name, 
                    datum: this.date,   
                    uhrzeit: this.time,
                    name: this.name,
                    unterschrift: this.signature,
                    bemerkung: this.bemerkung,
                    check1: this.checkPoints[0].check,
                    check2: this.checkPoints[1].check,
                    check3: this.checkPoints[2].check,
                    check4: this.checkPoints[3].check,
                    check5: this.checkPoints[4].check,
                    check6: this.checkPoints[5].check,
                    check7: this.checkPoints[6].check,
                    check8: this.checkPoints[7].check,
                    check9: this.checkPoints[8].check,
                    check10: this.checkPoints[9].check,
                    check11: this.checkPoints[10].check,
                    check12: this.checkPoints[11].check,
                    fotoFahrerhaus: this.imageFahrerhaus,
                    fotoLadeflaeche: this.imageLadeflaeche,
                };
                // this.mpoints.unshift(tempLog);
                // this.saveMpoints();
                // this.saveName();
                // if (this.$route.params.bereich == "5"){
                //     setTimeout(() => this.$router.push({path: "/temperaturen/"+this.$route.params.bereich+ '?title='+ this.$route.query.title }), 1500);
                // }else{
                //     if(this.messstellen.bereich[this.$route.params.bereich-1][this.mpoints[0].messstelle]){
                //         setTimeout(() =>{
                //             this.temperatur = "";
                //             this.signature = "";
                //             this.bemerkung = "";
                //             this.tick = 1;
                //             this.active = true;
                //             this.selectedMessstelle = this.messstellen.bereich[this.$route.params.bereich-1][this.mpoints[0].messstelle]
                //         }, 1500);
                //     }else{
                //         setTimeout(() => this.$router.push({path: "/temperaturen/"+this.$route.params.bereich+ '?title='+ this.$route.query.title }), 1500);
                //     }
                // }
                // setTimeout(() => this.$router.push({path: "/temperaturen/"+this.$route.params.bereich+ '?title='+ this.$route.query.title }), 1500);
                // Alter Weg: nach jedem Eintrag ein DB-Eintrag
                this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/checklist/driver/add', checklist, { headers: {'Authorization': this.auth }})
                .then(function(response) {
                    if(response.body.error){
                        console.log(response.body.error);
                        this.nextTick();
                        this.showErrorMessage = true;
                        setTimeout(() => this.$router.push({path: "/tagestour"}), 1500);
                    } else {
                        console.log(response)
                        setTimeout(() => this.$router.push({path: "/tagestour"}), 1500);
                    }                
                    
                });
            }
        },
        },
computed: {
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.required && errors.push('Bitte geben Sie Ihren Namen ein')
        return errors
      },
    },
    created: function(){
        this.subtitle += this.$route.params.id;
        this.fetchChecklist();
      
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#frame{
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;

}
.v-messages__message{
   color: rgb(255, 115, 0);
}
.instruction{
    text-align: center;
    font-weight: bold;
}
.pad{
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px ;
}
.messstelle{
    font-weight: bold;
    font-size: large;
}
.angaben{
font-size: large;
font-weight: bold;
}

.boldtxt{
  font-weight: bold;
}
img {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}

div.fileinputs {
	position: relative;
}

div.fakefile {
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 1;
}

input.file {
	position: relative;
	text-align: right;
	-moz-opacity: 0;
	filter:alpha(opacity: 0);
	opacity: 0;
	z-index: 2;
}
</style>

